import api from '../../utils/api'

import { useEffect, useState } from 'react'




/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormCloth from './form/FormCloth'

function EditCloth({id , btCancelAction, handleOnSuccess}){
    const [cloth, setCloth] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const {setFlashMessage} = useFlashMessage()

    useEffect(() => {

        api.get(`/cloth/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {

            setCloth(response.data.cloth)
        })
    }, [token, id])

    async function updateCloth(cloth) {
        let msgType = 'success'


        const data = await api.patch(`cloth/${cloth._id}`, cloth, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            }

    }


    return (
        cloth.name && (
            <FormCloth title="Editar Tecido" handleSubmit={updateCloth} btnText="Salvar" btCancelAction={btCancelAction} clothData={cloth} />
        )
    )
}

export default EditCloth
